import { render, staticRenderFns } from "./ProductOrdering.vue?vue&type=template&id=3232bce8&"
import script from "./ProductOrdering.vue?vue&type=script&lang=js&"
export * from "./ProductOrdering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports